import React, { FC } from 'react';
import ConfirmationEmailModal from '../../components/ConfirmationEmailModal/ConfirmationEmailModal';

const EmailConfirmationContainer: FC = () => {
  return <ConfirmationEmailModal />;
};

export default EmailConfirmationContainer;
